// extracted by mini-css-extract-plugin
export var excerpt = "content-module--excerpt--00559";